module.exports = __webpack_public_path__ + "img/logo.fbb350c1.png";